<template>
  <div>
    <!-- Search -->
    <WorkflowFilter />
    <DataTable
      :rowKeys="['workflowId']"
      :rows="workflows"
      :actions="[
        {
          name: 'workflow',
          label: 'View',
          params: { workflowId: 'workflowId' }
        }
      ]"
      :columns="[
        { name: 'workflowId', type: 'text' },
        { name: 'version', type: 'text' },
        { name: 'workflowType', type: 'text' },
        { name: 'status', type: 'text' },
        { name: 'executionTime', type: 'duration' },
        { name: 'startTime', type: 'date' },
        { name: 'endTime', type: 'date' },
        { name: 'failedReferenceTaskNames', type: 'text' },
        { name: 'reasonForIncompletion', type: 'text' }
      ]"
    />
    <!-- Pagination -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DataTable from '@/components/DataTable.vue'
import WorkflowFilter from '@/components/WorkflowFilter.vue'

export default {
  name: 'WorkflowList',
  computed: mapState(['workflows']),
  methods: mapActions(['getWorkflows']),
  created() {
    this.getWorkflows()
  },
  components: {
    DataTable,
    WorkflowFilter
  }
}
</script>
